import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import TextInputField from "@eres/forms-web/TextInputField";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { ErrorContainer } from "@eres/forms";
import { BuyerInfo, EmiratesID, IDType, PassportID, PrvSellLookUp, PvtSellLookUp } from "../../../apis/privatesell/enitites";
import FormRow from "@eres/forms-web/FormRow";
import { checkNonEmpty, } from "@my-dld/components/Form/FormField";
import { StringUtil } from "@eres/core";
import { populatePrvtSellLookup } from "../../../apis/privatesell/services";
import { handleDataUpdate, IPrivateSellForm, IPrivateSellFormProps, IPrivateSellFormState } from "../Component/Base";
import { dualDataManager } from "@eres/forms/valuemanager/DualDataManager";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import PickerInput from "@eres/forms-web/PickerInput";
import { serverDateToDate } from "@eres/core/dist/DateTime";
import { DisableEditOrgDataProvider } from "@eres/forms/providers/editable/OrgDataEditProvider";
import DateInputField from "@eres/forms-web/DateInputField";
import { serverDateConverter } from "@my-dld/utils/LookupUtil";

interface Props extends IPrivateSellFormProps {
	children?: any;
	buyerInfo?: BuyerInfo;
	IdType: IDType;
}

interface BuyerExtraProp extends BuyerInfo {
	birthPlaceNameEn?: string;
	birthPlaceNameAr?: string;
	buyerNameAr?: string;
	buyerNameEn?: string;
	passportIssuePlaceNameEn?: string;
	passportIssuePlaceNameAr?: string;
	identificationType?: string;
	identificationValue?: string;
}

interface State extends IPrivateSellFormState {
	errorContainer: ErrorContainer;
	IdType: IDType;
	Countries: PvtSellLookUp[];
	pvr_Gender: PvtSellLookUp[];
	PreferredLanguage: PvtSellLookUp[];
	orgData?: BuyerExtraProp;
	newData?: BuyerExtraProp;
	today: Date;
}

export default class BuyerInfoDetail extends Component<Props, State> implements IPrivateSellForm<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			orgData: normalizeBuyer( props.buyerInfo! ),
			newData: {},
			isValid: false,
			errorContainer: {},
			IdType: props.IdType,
			Countries: [],
			pvr_Gender: [],
			PreferredLanguage: [],
			today: new Date(),
		};
	}

	componentDidMount(): void {
		populatePrvtSellLookup( PrvSellLookUp.PRVSell_GENDER, this );
		populatePrvtSellLookup( PrvSellLookUp.PRVSell_COUNTRY, this );
		populatePrvtSellLookup( PrvSellLookUp.PRVSell_PREFERRED_LANGUAGE, this );
	}

	setError( key: string, error: string | undefined ) {
		this.setState( s => {
			return {
				errorContainer: {
					...s.errorContainer,
					[ key ]: error ? error : "",
				}
			};
		} );
	}

	isValid = ( _isUserAction?: boolean ) => {
		let isValid = true;
		let errorViews: ErrorContainer = {};
		const state: BuyerInfo = {
			...this.state.orgData,
			...this.state.newData,
		};
		isValid = checkNonEmpty( state, "buyerNameAr", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "buyerNameEn", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "birthPlaceNameEn", errorViews ) && isValid;
		if ( this.state.IdType.Id === EmiratesID.Identity ) {
			isValid = checkNonEmpty( state, "emiratesId", errorViews ) && isValid;
			isValid = checkNonEmpty( state, "emiratesIdExpiry", errorViews ) && isValid;
		} else {
			isValid = checkNonEmpty( state, "passportNumber", errorViews ) && isValid;
			isValid = checkNonEmpty( state, "passportExpiryDate", errorViews ) && isValid;
			isValid = checkNonEmpty( state, "passportIssuePlaceNameAr", errorViews ) && isValid;
			isValid = checkNonEmpty( state, "passportIssuePlaceNameEn", errorViews ) && isValid;
		}
		isValid = checkNonEmpty( state, "gender", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "nationality", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "birthDate", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "mobile", errorViews ) && isValid;
		if ( isValid ) {
			isValid = validateMobile( errorViews, state, "mobile" ) && isValid;
		}
		isValid = checkNonEmpty( state, "email", errorViews ) && isValid;
		if ( isValid ) {
			isValid = validateEmail( errorViews, state, "email" ) && isValid;
		}
		isValid = checkNonEmpty( state, "preferredLanguage", errorViews ) && isValid;
		this.setState( { errorContainer: errorViews } );
		return isValid;
	};

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		const oldData = this.getData( prevState );
		const newData = this.getData( this.state );
		handleDataUpdate( oldData, newData, prevState, this );
	}

	getData = ( state: State = this.state ) => {
		const data = {
			...state.orgData,
			...state.newData,
		};
		const isUAEResidence = this.state.IdType.Id === EmiratesID.Identity;
		return {
			...data,
			name: { arabicName: data.buyerNameAr, englishName: data.buyerNameEn },
			passportIssuePlace: { arabicName: data.passportIssuePlaceNameAr, englishName: data.passportIssuePlaceNameEn },
			birthPlace: { arabicName: data.birthPlaceNameAr, englishName: data.birthPlaceNameEn },
			Countries: undefined,
			pvr_Gender: undefined,
			PreferredLanguage: undefined,
			editableName: undefined,
			IdType: undefined,
			isValid: undefined,
			errorContainer: undefined,
			today: undefined,
		};
	};


	render() {
		const { readonly, children } = this.props;
		const { errorContainer, IdType, orgData, newData, today } = this.state;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-4 form-group",
			valueManager: dualDataManager,
			errorManager: defaultErrorManager,
		};
		const orgProp = {
			...filedProps,
			enableEditProvider: DisableEditOrgDataProvider,
		};
		const kvProp = { inputClassName: "form-control", holder: this, containerClassName: "col-md-6 form-group" };
		return (
			<div className="tender-registration-form">
				<FormSection title={ Strings.buyer_information }>
					<FormRow>
						<TextInputField
							{ ...orgProp }
							id={ "buyerNameAr" }
							required={ true }
							type={ "arabic" }
							label={ Strings.arabic_name }
						/>
						<TextInputField
							{ ...orgProp }
							id={ "buyerNameEn" }
							required={ true }
							type={ "english" }
							label={ Strings.english_name }
						/>
						<PickerInput
							{ ...orgProp }
							label={ Strings.gender }
							id={ "gender" }
							items={ this.state.pvr_Gender }
							toIdentifier={ idExtractor }
							required={ true }
							error={ errorContainer.gender }/>
						<PickerInput
							{ ...orgProp }
							label={ Strings.nationality }
							id={ "nationality" }
							items={ this.state.Countries }
							toIdentifier={ idExtractor }
							required={ true }
							enableEditProvider={ DisableEditOrgDataProvider }
							error={ errorContainer.nationality }/>
						<DateInputField
							{ ...orgProp }
							required={ true }
							id={ "birthDate" }
							label={ Strings.date_of_birth }
							extraOpts={ {
								maxDate: today,
							} }
							valueConverter={ serverDateConverter }
							error={ errorContainer.birthDate }
							extraInputClassName={ "data-picker-icon" }
						/>
						<TextInputField
							{ ...orgProp }
							id={ "birthPlaceNameAr" }
							label={ Strings.birth_place_arabic }
							type={ "arabic" }
							error={ errorContainer.BirthPlaceNameAr }/>
						<TextInputField
							{ ...orgProp }
							id={ "birthPlaceNameEn" }
							required={ true }
							label={ Strings.birth_place_english }
							type={ "english" }
							error={ errorContainer.BirthPlaceNameEn }/>
						<TextInputField
							{ ...orgProp }
							label={ Strings.identification_type }
							id={ "identificationType" }
							enableEditProvider={ DisableEditOrgDataProvider }/>
						<TextInputField
							{ ...filedProps }
							label={ Strings.identity_number }
							id={ "identificationValue" }
							enableEditProvider={ DisableEditOrgDataProvider }/>
						{
							IdType.Id === EmiratesID.Identity &&
							<DateInputField
								{ ...orgProp }
								required={ true }
								id={ "emiratesIdExpiry" }
								label={ Strings.identity_expiry }
								valueConverter={ serverDateConverter }
								extraOpts={ {
									minDate: today,
								} }
								error={ errorContainer.emiratesIdExpiry }
								extraInputClassName={ "data-picker-icon" }
							/>
						}
						{ IdType.Id === PassportID.Identity &&
							<>
								<DateInputField
									{ ...orgProp }
									required={ true }
									id={ "passportExpiryDate" }
									label={ Strings.identity_expiry }
									valueConverter={ serverDateConverter }
									extraOpts={ {
										minDate: today,
									} }
									error={ errorContainer.passportExpiryDate }
									extraInputClassName={ "data-picker-icon" }
								/>
								<TextInputField
									{ ...orgProp }
									required={ true }
									id={ "passportIssuePlaceNameAr" }
									label={ Strings.passport_issue_place_ar }
									type={ "arabic" }
									error={ errorContainer.passportIssuePlaceNameAr }/>
								<TextInputField
									{ ...orgProp }
									required={ true }
									id={ "passportIssuePlaceNameEn" }
									label={ Strings.passport_issue_place }
									type={ "english" }
									error={ errorContainer.passportIssuePlaceNameEn }/>
							</>
						}
						<TextInputField
							{ ...orgProp }
							id={ "mobile" }
							required={ true }
							label={ Strings.mobile_number }
						/>
						<TextInputField
							{ ...orgProp }
							placeHolder={ Strings.email_placeholder }
							id={ "email" }
							error={ errorContainer.email }
							label={ Strings.email }
							required={ true }
							maxLength={ 256 }
						/>
						<PickerInput
							{ ...orgProp }
							label={ Strings.communication_language }
							id={ "preferredLanguage" }
							items={ this.state.PreferredLanguage }
							toIdentifier={ idExtractor }
							required={ true }
							error={ errorContainer.preferredLanguage }/>
					</FormRow>
				</FormSection>
			</div>
		);
	}

}
const getValeDate = ( date?: string ) => serverDateToDate( date ? date : "" );
const idExtractor = ( e: PvtSellLookUp ) => e ? "" + e.identity : undefined;

function validateMobile( errorViews: ErrorContainer, state: any,
                         key: string = "Mobile" ): boolean {
	let isValid = true;
	let mob = StringUtil.normaliseMobileNumber( state[ key ] );
	if ( mob == undefined || mob.length < 12 ) {
		isValid = false;
		errorViews[ key ] = Strings.invalid_mobile;
	}
	return isValid;
}

function validateEmail( errorViews: ErrorContainer,
                        state: any,
                        key: string = "Email" ): boolean {
	let isValid = true;
	let email = state[ key ];
	if ( !StringUtil.isEmailAddress( email ) ) {
		isValid = false;
		errorViews[ key ] = Strings.invalid_email;
	}
	return isValid;
}


function normalizeBuyer( buyer: BuyerInfo ): BuyerExtraProp {
	let returnVal: BuyerExtraProp = {
		...buyer,
		buyerNameEn: buyer.name?.englishName,
		buyerNameAr: buyer.name?.arabicName,
		birthPlaceNameEn: buyer.birthPlace?.englishName,
		birthPlaceNameAr: buyer.birthPlace?.arabicName,
		passportIssuePlaceNameEn: buyer.passportIssuePlace?.englishName,
		passportIssuePlaceNameAr: buyer.passportIssuePlace?.arabicName,
		identificationType: buyer.emiratesId ? Strings.eid : Strings.passport_information,
		identificationValue: buyer.emiratesId ? buyer.emiratesId : buyer.passportNumber ?? "",
	};
	return returnVal;
}
